import { timeAgo } from "../lib/format";

// Structural type covering both google_ads_sync_runs and meta_ads_sync_runs rows.
export type SyncRunLike = {
  started_at: string;
  status: string;
  campaigns_upserted: number | null;
  metrics_upserted: number | null;
  error: string | null;
};

type SyncStatusProps = {
  runs: SyncRunLike[];
  label?: string;
};

export function SyncStatus({ runs, label }: SyncStatusProps) {
  const latest = runs[0];
  const lastSuccess = runs.find((r) => r.status === "ok");

  if (!latest) {
    return (
      <div className="sync-status" data-status="idle">
        <span className="dot" />
        <div>
          <strong>{label ?? "No syncs yet"}</strong>
          <p>Schedule pg_cron and the function will start running.</p>
        </div>
      </div>
    );
  }

  const status = latest.status;
  const prefix = label ? `${label} · ` : "";
  return (
    <div className="sync-status" data-status={status}>
      <span className="dot" />
      <div>
        <strong>
          {status === "ok" && `${prefix}Last sync OK`}
          {status === "running" && `${prefix}Sync running`}
          {status === "error" && `${prefix}Last sync failed`}
        </strong>
        <p>
          {timeAgo(latest.started_at)}
          {status === "ok" && latest.campaigns_upserted != null && (
            <> · {latest.campaigns_upserted} campaigns, {latest.metrics_upserted} metric rows</>
          )}
          {status === "error" && latest.error && (
            <> · <code>{truncate(latest.error, 120)}</code></>
          )}
          {status === "error" && lastSuccess && (
            <> · last OK {timeAgo(lastSuccess.started_at)}</>
          )}
        </p>
      </div>
    </div>
  );
}

function truncate(s: string, n: number): string {
  return s.length > n ? s.slice(0, n - 1) + "…" : s;
}
